import { useState, useEffect } from 'react'
import { User, UserRole } from '../types'
import { MOCK_TENANT, MOCK_LANDLORD } from '../utils/mockData'

export function useAuth() {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate checking auth state from localStorage
    const storedUser = localStorage.getItem('renta_user')
    if (storedUser) {
      setUser(JSON.parse(storedUser))
    }
    setIsLoading(false)
  }, [])

  const login = async (email: string, role: UserRole) => {
    setIsLoading(true)
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1000))

    let mockUser: User

    if (role === 'tenant') {
      mockUser = { ...MOCK_TENANT, email }
    } else if (role === 'landlord') {
      mockUser = { ...MOCK_LANDLORD, email }
    } else if (role === 'admin') {
      mockUser = {
        id: 'admin1',
        name: 'System Admin',
        email,
        role: 'admin',
        isVerified: true,
      }
    } else if (role === 'employer') {
      mockUser = {
        id: 'employer1',
        name: 'HR Manager',
        email,
        role: 'employer',
        isVerified: true,
        companyName: 'Tech Corp',
        industry: 'Technology',
        employeeCount: 150,
        activeDeductions: 12,
        pendingRequests: 3,
      }
    } else {
      throw new Error('Invalid role')
    }

    localStorage.setItem('renta_user', JSON.stringify(mockUser))
    setUser(mockUser)
    setIsLoading(false)
    return mockUser
  }

  const logout = () => {
    localStorage.removeItem('renta_user')
    setUser(null)
    window.location.href = '/'
  }

  return { user, login, logout, isLoading }
}
